import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    localStorage.removeItem('ibn_token');
    window.location.href = '/login';
  };

  handleHardReload = () => {
    if ('caches' in window) {
      caches.keys().then(names => names.forEach(n => caches.delete(n)));
    }
    window.location.reload(true);
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center space-y-4">
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900">Erreur d'affichage</h2>
            <p className="text-gray-500 text-sm">
              Une erreur est survenue lors du chargement de la page. 
              Cela peut être causé par un cache navigateur obsolète.
            </p>
            <div className="space-y-2 pt-2">
              <button
                onClick={this.handleHardReload}
                className="w-full px-4 py-2.5 bg-[hsl(222,47%,11%)] text-white rounded-lg font-medium text-sm hover:bg-[hsl(222,47%,18%)] transition-colors"
                data-testid="error-reload-btn"
              >
                Recharger la page
              </button>
              <button
                onClick={this.handleReload}
                className="w-full px-4 py-2.5 border border-gray-200 text-gray-700 rounded-lg font-medium text-sm hover:bg-gray-50 transition-colors"
                data-testid="error-reconnect-btn"
              >
                Se reconnecter
              </button>
            </div>
            <p className="text-xs text-gray-400 pt-2">
              Si le problème persiste, essayez Ctrl+Shift+R pour forcer le rechargement.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
